import React, {useEffect, useState} from 'react';
import useAuth from "../../../hooks/useAuth";
import PieTurnover from "../../../Graphs/PieTurnover";
import {byProductMode, byProductTypeMode} from "../../../Graphs/constants";

function Distribution({orders}) {

  return (
    <div>
        <PieTurnover ordersData={orders} displayMode={byProductMode}/>
    </div>
  )
}

export default Distribution